"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const Box_1 = __importDefault(require("@mui/material/Box"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const RefreshRounded_1 = __importDefault(require("@mui/icons-material/RefreshRounded"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const SyncProblem_1 = __importDefault(require("@mui/icons-material/SyncProblem"));
const auth_1 = require("companion-app-components/flux/auth");
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const ErrorLinearProgress_1 = __importDefault(require("components/ErrorLinearProgress"));
const selectors = __importStar(require("data/app/selectors"));
const actions_1 = require("data/app/actions");
const styles_1 = require("./styles");
const useStyle = (0, mui_1.makeStyles)()(styles_1.styles);
const renderMultipleMessages = (updateAllMessages) => updateAllMessages.map((message) => {
    if (updateAllMessages.size > 7) {
        return (<Box_1.default key={message} component="span" display="inline" mr={0.5}>
          {message}
        </Box_1.default>);
    }
    return <div key={message}>{message}</div>;
});
const RefreshButton = ({ size, isInAccountBar, closeHeader }) => {
    var _a, _b;
    const { classes, theme } = useStyle();
    const disableRefreshButton = (0, react_redux_1.useSelector)(selectors.disableRefreshButton);
    const isRefreshing = (0, react_redux_1.useSelector)(selectors.isRefreshing);
    const updateAllFailed = (0, react_redux_1.useSelector)(selectors.getUpdateAllFailed);
    // TODO: remove type once new app-component is installed
    const updateAllMessages = (0, react_redux_1.useSelector)(selectors.getUpdateAllMessages);
    const datasetId = (0, react_redux_1.useSelector)(auth_1.authSelectors.getDatasetId);
    const dispatch = (0, react_redux_1.useDispatch)();
    const refreshAction = (e) => {
        closeHeader === null || closeHeader === void 0 ? void 0 : closeHeader();
        e.stopPropagation();
        dispatch((0, actions_1.appRefreshAll)(undefined, { context: 'refreshAll' }));
    };
    // Main icon button that acme and quicken use
    const refreshIconRoot = (<IconButton_1.default tabIndex={isInAccountBar ? -1 : 0} aria-label="Refresh All" disabled={disableRefreshButton} classes={{
            root: classes.buttonRoot,
            disabled: classes.refreshButtonDisabled,
        }} 
    // @ts-expect-error: No overload matches this call.
    style={{ color: !isInAccountBar && ((_a = theme.components) === null || _a === void 0 ? void 0 : _a.navigation.iconColor), padding: !isInAccountBar && 0 }} onClick={refreshAction} size="large">
      {updateAllFailed ? <SyncProblem_1.default style={{ fontSize: size }}/> : <RefreshRounded_1.default style={{ fontSize: size }}/>}
    </IconButton_1.default>);
    if (!datasetId) {
        return null;
    }
    return isInAccountBar ?
        <>
      {isRefreshing && (<IconButton_1.default aria-label="Refresh All Busy" disabled classes={{ root: classes.buttonRoot }} size="large">
          <CircularProgress_1.default size={size || 22} 
            // @ts-expect-error: Property 'accountDrawer' does not exist on type
            style={{ color: theme.components.accountDrawer.refreshIcon }}/>
        </IconButton_1.default>)}
      {!isRefreshing && (<QTip_1.default html={updateAllMessages && updateAllMessages.size ?
                    renderMultipleMessages(updateAllMessages) :
                    <div>Update All</div>} placement="right">
          {refreshIconRoot}
        </QTip_1.default>)}
    </> :
        <div role="button" tabIndex={0} onClick={refreshAction} onKeyPress={refreshAction} className={(0, classnames_1.default)(classes.refreshDivButton, disableRefreshButton && classes.disabledRefreshDivButton)}>
      {isRefreshing ? (<IconButton_1.default aria-label="Refresh All Busy" disabled classes={{ root: classes.buttonRoot }} style={{ padding: 0 }} size="large">
          <CircularProgress_1.default size={size || 22} 
            // @ts-expect-error: Property 'navigation' does not exist on type 
            style={{ color: theme.components.navigation.iconColor }}/>
        </IconButton_1.default>) : (<QTip_1.default html={(_b = updateAllMessages === null || updateAllMessages === void 0 ? void 0 : updateAllMessages.map) === null || _b === void 0 ? void 0 : _b.call(updateAllMessages, (message) => <div key={message}>{message}</div>)} placement="right">
          {refreshIconRoot}
        </QTip_1.default>)}

      <Typography_1.default style={{ marginLeft: 24, textAlign: 'left' }} className={classes.navText}>
        Refresh
      </Typography_1.default>

      {updateAllFailed && <ErrorLinearProgress_1.default />}
    </div>;
};
exports.default = RefreshButton;
